export default __webpack_public_path__ + "static/media/calendar-illustration.0fdb6a19.svg";